import { NodeViewContent, type NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import { Badge, Button } from "@workith/ui";
import { appendFrontMatterField } from "./frontMatterCommands";
import {
  frontMatterValidation,
  handleFrontMatterControlKeyDown,
  useFrontMatterEditorSync,
} from "./frontMatterControls";

export function FrontMatterNodeView({ editor, node, getPos }: NodeViewProps) {
  const editable = useFrontMatterEditorSync(editor);
  const { valid } = frontMatterValidation(node);
  const rawPos = getPos();
  const cardPos = typeof rawPos === "number" ? rawPos : null;

  return (
    <NodeViewWrapper
      as="section"
      data-type="frontMatter"
      className="not-prose my-4 rounded-lg border border-border bg-muted/40"
    >
      <header
        className="flex items-center justify-between gap-3 border-b border-border px-4 py-3"
        contentEditable={false}
      >
        <div className="flex items-center gap-2">
          <strong className="text-sm">문서 메타데이터</strong>
          <Badge variant="secondary">YAML</Badge>
          {!valid && (
            <span role="alert" className="text-xs text-destructive">
              Markdown 출력이 유효하지 않을 수 있습니다.
            </span>
          )}
        </div>
        <Button
          type="button"
          size="sm"
          variant="outline"
          aria-label="필드 추가"
          data-frontmatter-control
          disabled={!editable || cardPos === null}
          onMouseDown={(event) => event.preventDefault()}
          onKeyDown={(event) =>
            handleFrontMatterControlKeyDown(event, editor, cardPos ?? undefined)
          }
          onClick={cardPos === null ? undefined : () => appendFrontMatterField(editor, cardPos)}
        >
          필드 추가
        </Button>
      </header>
      <NodeViewContent className="divide-y divide-border" />
    </NodeViewWrapper>
  );
}
